var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBglines(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 432,
    height: 286,
    viewBox: "0 0 432 286",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.6055 225.598C16.4935 183.252 50.9322 84.4804 156.85 104.335C240.024 119.926 268.904 89.8984 276.991 59.8713C296.896 -14.0413 364.786 -11.0389 441.029 28.6893",
    stroke: "#e9a5f361"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1 323C3.97317 279.358 39.4275 177.563 148.469 198.025C234.096 214.093 263.828 183.146 272.153 152.2C292.645 76.0248 362.537 79.1192 441.028 120.064",
    stroke: "#e9a5f361"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1 264.559C3.97317 220.917 39.4275 119.121 148.469 139.583C234.096 155.652 263.828 124.705 272.153 93.759C292.645 17.5837 362.537 20.678 441.028 61.6224",
    stroke: "#e9a5f361"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBglines);
export default __webpack_public_path__ + "static/media/bglines.c0083f71d90717321332708845c3a765.svg";
export { ForwardRef as ReactComponent };